export const navItems = [
  { path: '/', label: 'Home', icon: 'home' },
  { path: '/ourwork', label: 'Our Work', icon: 'photo_library' },
  { path: '/products', label: 'Products', icon: 'inventory_2' },
  // Temporarily commented out
  // { path: '/favorites', label: 'Favorites', icon: 'favorite' },
  // { path: '/orders', label: 'Orders', icon: 'receipt_long' },
  // { path: '/profile', label: 'Profile', icon: 'person' },
  { path: '/contact', label: 'Contact', icon: 'mail' },
  { path: '/faq', label: 'FAQ', icon: 'help' },
  // Temporarily hidden - Home page now has grid layout
  // { path: '/browse', label: 'Browse', icon: 'search' },
];
